export const isDevMode: boolean = (process.env.REACT_APP_BACKEND_URL ?? '').indexOf('localhost') > 0;
